import styled from "styled-components"

export const StyledSignUpDescription = styled.div`
    margin-bottom: 5px;
`
